<template>
  <div class="contents"  v-title="pageTitle">
     <div class="bg_heard"> 
        <img class="img" src="@/assets/bg.jpg" />
        <div style="position: relative;">
            <div style="position: fixed;z-index: 1;top: 20px; display: flex;align-items: center;">
               <img class="img_logo"  :src="msgdata!=undefined? msgdata.avatar:''" />
               <div style="margin-left: 10px;font-size: 20px;color: #fff;">{{ msgdata!=undefined? msgdata.nickName:'' }}</div>
               <div style="margin-left: 10px;"> 
                   <van-button type="danger" round size="small" @click.stop="loginout">退出登录</van-button>
               </div>
               <!-- <div style="margin-left: 50px;"> 
                   <van-button v-if="t&y" type="primary" round size="small" @click.stop="WithDraw(0)">关闭提现</van-button>
                   <van-button v-else-if="t&!y" type="primary" round size="small" @click.stop="WithDraw(1)">开通提现</van-button>
               </div> -->
           </div>
        </div>
        <div class="conts"> 
            <div v-for="(items,index) in icons" :key="index">
              <div class="insaide" @click.stop="Event(index)" v-if="index!==3&index!==2">
                 <img :src="items.ico" class="imgs" />
                 <div class="text">{{ items.name }}</div>
              </div> 
              <div class="insaide" v-if="index==3&t&y" @click.stop="Event(index)">
                 <img :src="items.ico" class="imgs" />
                 <div class="text">{{ items.name }}</div>
               </div>
           </div>
        </div>

     </div>
  </div>
</template>

<script>
import request from '../../api/request'
// import { QrcodeStream } from 'vue-qrcode-reader'
export default {
  data() {
     return {
        icons: [{ 'name': '订单管理', 'ico': require('@/assets/order_management.png') }, { 'name': '售后管理', 'ico': require('@/assets/Productlist.png') }, { 'name': '商品上架', 'ico': require('@/assets/upload.png') }, { 'name': '提 现', 'ico': require('@/assets/Withdrawal.png') }],
        msgdata: {},
        pageTitle:"管理平台",t:false, y:false
     }
  },
  components: {
   //  QrcodeStream
  },
  mounted() {
    let that=this
     request.GetSessionStorage('usermsg').then(res => {
      that.msgdata=res
     })
     this.msgdata = JSON.parse(localStorage.getItem('usermsg'))
     this.token=localStorage.getItem('token_yr')
     if(localStorage.getItem('openId_yr')!=undefined) {this.openId=localStorage.getItem('openId_yr').replace('"', "").replace('"', "");this.checkBindOpenId()}
     else{this.openId=''; this.checkBindOpenId()} 
     console.log(this.openId)
  
  },
  methods: {
   onDecode(decodedString) {
      console.log(decodedString)
      // 处理扫描结果
    },
   checkBindOpenId(){
         request.getcommerlist({orgCode:this.msgdata.orgCode},'/admin/withDraw/checkBindOpenId','get',this.token,res=>{
             console.log(res)
             if(res.errno== 0 ) {
               if(res.data!==undefined&res.data!='') {
                  console.log(res.data)
                  console.log(this.openId)
                  if(this.openId==res.data) {
                     this.t=true
                     this.y=true
                  }else{
                     this.t=false
                     this.y=false
                  }
               }else{
                  this.t=true
                  this.y=false
               }
             }else{
                  this.t=true
                  this.y=false
             }
           
         })
      },
      //绑定用户
      WithDraw(type) {
         let that = this

         return
         that.$dialog.alert({
            title: '提示',
            message: type==1?'是否开通提现？': '是否关闭提现？',
            showCancelButton: true,
         }).then(() => {
            const parms = {
               type: type,
               openId: that.openId,
               orgCode: that.msgdata.orgCode
            }
            request.postOther(parms, '/admin/withDraw/bindOpenId', 'post', that.token, res => {
               console.log(res)
               this.$toast(res.errmsg)
               if(res.errno==0){
                  if(type==1){
                  this.t=true
                  this.y=true
                 }else{
                  this.t=true
                  this.y=false
                 }
               }  
            })
         }).catch(() => { });

      },

     loginout(){
      this.$dialog.alert({
                 title:'提示',
                 message: '是否退出登陆？',
                 showCancelButton:true,
               }).then(() => {
                  localStorage.setItem('ulogin',true)
                  request.removeItem('token_yr')
                  this.$router.replace({ path: '/test', query: {} })
             }).catch(()=>{});
      
   },
     Event(e){
        switch(e){
           case 0:
               this.$router.push({ path: '/order_management', query: {} })
              break;
           case 1:
           this.$router.push({ path: '/After_sales', query: {} })
              break;
            case 2:
            this.$router.push({ path: '/Upload', query: {} })
               break;
            case 3:
            this.$router.push({path:'/Withdrawal',query:{}})
               break;
        }
     }
  }
}
</script>

<style scoped lang="less">
  .contents{
  background: #fff;
   .bg_heard{
       // background-image: url('../assets/bg.jpg') no-repeat;
       .img{
       width: 100%;
       height: 100px;
     }
     .img_logo{
       width: 50px;
       margin-left: 20px;
       border-radius: 50px;
     }
     .conts{
        
         margin-top: 0px;
         display: flex;
         flex-wrap: wrap;
         padding: 10px;
        //  justify-content: space-between;
         .insaide{
            .text{font-size: 15px;}
           .imgs{width: 70px;height: 70px;margin:9px;margin-top: 15px;border-radius: 50px;}
         }
       
     }
     
   }
     
  }
</style>